// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"715":"list","962":"home"}[chunkId] || chunkId) + "." + {"382":"45ee6659","570":"62940b08","715":"d8e177bb","962":"43d156ad"}[chunkId] + ".js";
};